import React, { useEffect } from "react";
import "./styles.css";
import { useLocation, useParams } from "react-router-dom"; // Import useLocation to get the current path
import { useMsal } from "@azure/msal-react";
import { InteractionStatus } from "@azure/msal-browser";
import { useSidebar } from "./providers/SidebarContext";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { useAuth } from "./providers/AuthContext";

import LoginPage from "./pages/LoginPage";
import { SidebarProvider } from "./providers/SidebarContext";
import NotAuthorizedPage from "./pages/NotAuthorizedPage";
import OverviewPage from "./pages/OverviewPage";
import TenantsPage from "./pages/tenant/TenantsPage";
import AgreementsPage from "./pages/agreement/AgreementsPage";
import CreateAgreementPage from "./pages/agreement/CreateAgreementPage";
import EditAgreementPage from "./pages/agreement/EditAgreementPage";
import UsersPage from "./pages/user/UsersPage";
import EditUserPage from "./pages/user/EditUserPage";
import CreateUserPage from "./pages/user/CreateUserPage";
import OffboardUserPage from "./pages/offboarding/OffboardUserPage";
import LicensesPage from "./pages/license/LicensesPage";
import EditLicensesPage from "./pages/license/EditLicensesPage";
import ExamplePage from "./pages/example/ExamplePage";
import NotFoundPage from "./pages/NotFountPage";
import AccessDeniedPage from "./pages/AccessDeniedPage";
import LoadingPage from "./pages/LoadingPage";
import AddOnServicePage from "./pages/addOnService/AddOnServicePage";
import EditAddOnServicePage from "./pages/addOnService/EditAddOnServicePage";
import CreateAddOnServicePage from "./pages/addOnService/CreateAddOnServicePage";
import IndexAdjustmentsPage from "./pages/indexAdjustments/IndexAdjustmentsPage";
import EditIndexAdjustmentPage from "./pages/indexAdjustments/EditIndexAdjustmentPage";
import CreateIndexAdjustmentPage from "./pages/indexAdjustments/CreateIndexAdjustmentPage";
import HistoryBillingPage from "./pages/historybilling/HistoryBillingPage";
import EditHistoryBillingPage from "./pages/historybilling/EditHistoryBillingPage";
import CreateHistoryBillingPage from "./pages/historybilling/CreateHistoryBillingPage";
import BillingOverviewPage from "./pages/BillingOverviewPage";
import AgreementValueSummaryPage from "./pages/AgreementValueSummaryPage";
import EditTenantPage from "./pages/tenant/EditTenantPage";
import CreateTenantPage from "./pages/tenant/CreateTenantPage";
import BillingPage from "./pages/billingGroups/BillingPage";
import EditBillingPage from "./pages/billingGroups/EditBillingPage";
import CreateBillingPage from "./pages/billingGroups/CreateBillingPage";
import AccountPage from "./pages/accountType/AccountPage";
import EditAccountPage from "./pages/accountType/EditAccountPage";
import CreateAccountTypePage from "./pages/accountType/CreateAccountTypePage";
import AgreementServicesPage from "./pages/agreementServices/AgreementServicesPage";
import CreateAgreementServicesPage from "./pages/agreementServices/CreateAgreementServicesPage";
import EditAgreementServicesPage from "./pages/agreementServices/EditAgreementServicesPage";
import FinancialPage from "./pages/financial/FinancialPage";
import BillingHistoryPage from "./pages/BillingHistoryPage";
import NewUserForm from "./pages/NewUserForm";
import UserDevicePage from "./pages/userDevice/UserDevicePage";
import CreateUserDevicePage from "./pages/userDevice/CreateUserDevicePage";
import EditUserDevicePage from "./pages/userDevice/EditUserDevicePage";
import EditUserProgramPage from "./pages/userProgram/EditUserProgramPage";
import CreateUserProgramPage from "./pages/userProgram/CreateUserProgramPage";
import UserProgramPage from "./pages/userProgram/UserProgramPage";
import DomainsPage from "./pages/domains/DomainsPage";
import EditDomainsPage from "./pages/domains/EditDomainsPage";
import DeviceInventoryPage from "./pages/deviceInventory/DeviceInventoryPage";
import DeviceInventoryDetailPage from "./pages/deviceInventory/DeviceInventoryDetailPage";
import HardwareCataloguePage from "./pages/hardwareCatalogue/HardwareCataloguePage";
import CreateHardwareProductPage from "./pages/hardwareCatalogue/CreateHardwareProductPage";
import EditHardwareProductPage from "./pages/hardwareCatalogue/EditHardwareProductPage";

function App() {
  const { isAuthenticated, login, loading, isRole, isRolesSet } = useAuth();
  useEffect(() => {
    console.log("Is Authenticated: ", isAuthenticated);
  }, [isAuthenticated]);

  useEffect(() => {
    console.log("Is Roles set: ", isRolesSet);
  }, [isRole, isRolesSet]);

  if (loading) {
    return <LoadingPage></LoadingPage>;
  }

  return (
    <SidebarProvider>
      <Routes>
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <AgreementsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/new-user-form"
          element={
            <ProtectedRoute>
              <NewUserForm />
            </ProtectedRoute>
          }
        />

        <Route
          path="/history-billing"
          element={
            <ProtectedRoute>
              <BillingHistoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/history-billing/:billingHistoryPublicId"
          element={
            <ProtectedRoute>
              <EditHistoryBillingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/billing-overview"
          element={
            <ProtectedRoute>
              <BillingOverviewPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/agreement-value-summary"
          element={
            <ProtectedRoute>
              <AgreementValueSummaryPage />
            </ProtectedRoute>
          }
        />

        {/*         <Route
          path="/agreements"
          element={
            <ProtectedRoute>
              <AgreementsPage />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/:agreementPublicId"
          element={
            <ProtectedRoute>
              <EditAgreementPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agreement/create"
          element={
            <ProtectedRoute>
              <CreateAgreementPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId"
          element={
            <ProtectedRoute>
              <EditTenantPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/create-tenant"
          element={
            <ProtectedRoute>
              <CreateTenantPage />
            </ProtectedRoute>
          }
        />

        {/*         <Route
          path="/:agreementPublicId/tenants"
          element={
            <ProtectedRoute>
              <TenantsPage />
            </ProtectedRoute>
          }
        /> */}

        <Route
          path="/:agreementPublicId/:tenantPublicId/users"
          element={
            <ProtectedRoute>
              <UsersPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/users/:userPublicId"
          element={
            <ProtectedRoute>
              <EditUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/:tenantPublicId/create-user"
          element={
            <ProtectedRoute>
              <CreateUserPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/:tenantPublicId/offboard-user"
          element={
            <ProtectedRoute>
              <OffboardUserPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/licenses"
          element={
            <ProtectedRoute>
              <LicensesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/:tenantPublicId/licenses/:licenseCompositeKey"
          element={
            <ProtectedRoute>
              <EditLicensesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/add-on-service"
          element={
            <ProtectedRoute>
              <AddOnServicePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/add-on-service/:addOnServicePublicId"
          element={
            <ProtectedRoute>
              <EditAddOnServicePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/add-on-service/create"
          element={
            <ProtectedRoute>
              <CreateAddOnServicePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/hardware-catalogue"
          element={
            <ProtectedRoute>
              <HardwareCataloguePage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hardware-catalogue/create"
          element={
            <ProtectedRoute>
              <CreateHardwareProductPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/hardware-catalogue/:hardwareProductPublicId"
          element={
            <ProtectedRoute>
              <EditHardwareProductPage />
            </ProtectedRoute>
          }
        />
        
          <Route
            path="/:agreementPublicId/domains"
            element={
              <ProtectedRoute>
                <DomainsPage />
              </ProtectedRoute>
            }
          />

        <Route
          path="/:agreementPublicId/device-inventory"
          element={
            <ProtectedRoute>
              <DeviceInventoryPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/device-inventory/:managedDevicePublicId"
          element={
            <ProtectedRoute>
              <DeviceInventoryDetailPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/billing-groups"
          element={
            <ProtectedRoute>
              <BillingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/billing-groups/:billingGroupPublicId"
          element={
            <ProtectedRoute>
              <EditBillingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/billing-group/create"
          element={
            <ProtectedRoute>
              <CreateBillingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/account-types"
          element={
            <ProtectedRoute>
              <AccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/account-types/:accountTypePublicId"
          element={
            <ProtectedRoute>
              <EditAccountPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/account-type/create"
          element={
            <ProtectedRoute>
              <CreateAccountTypePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/indexadjustment"
          element={
            <ProtectedRoute>
              <IndexAdjustmentsPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/indexadjustment/:indexAdjustmentPublicId"
          element={
            <ProtectedRoute>
              <EditIndexAdjustmentPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/indexadjustment/create"
          element={
            <ProtectedRoute>
              <CreateIndexAdjustmentPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/history-billing"
          element={
            <ProtectedRoute>
              <HistoryBillingPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/history-billing/:billingHistoryPublicId"
          element={
            <ProtectedRoute>
              <EditHistoryBillingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/:agreementPublicId/history-billing/create"
          element={
            <ProtectedRoute>
              <CreateHistoryBillingPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agreement-service"
          element={
            <ProtectedRoute>
              <AgreementServicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agreement-service/create"
          element={
            <ProtectedRoute>
              <CreateAgreementServicesPage />
            </ProtectedRoute>
          }
        />
        <Route
          path="/agreement-service/:agreementServicePublicId"
          element={
            <ProtectedRoute>
              <EditAgreementServicesPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/financial"
          element={
            <ProtectedRoute>
              <FinancialPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/user-devices"
          element={
            <ProtectedRoute>
              <UserDevicePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/create-user-device"
          element={
            <ProtectedRoute>
              <CreateUserDevicePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/user-devices/:userDevicePublicId"
          element={
            <ProtectedRoute>
              <EditUserDevicePage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/user-programs"
          element={
            <ProtectedRoute>
              <UserProgramPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/create-user-program"
          element={
            <ProtectedRoute>
              <CreateUserProgramPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/:agreementPublicId/user-programs/:userProgramPublicId"
          element={
            <ProtectedRoute>
              <EditUserProgramPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="*"
          element={
            <ProtectedRoute>
              <NotFoundPage />
            </ProtectedRoute>
          }
        />

        <Route
          path="/unauthorized"
          element={<NotAuthorizedPage />} // Add the NotAuthorizedPage route
        />

        <Route path="/login" element={<LoginPage />} />
      </Routes>
    </SidebarProvider>
  );
}

export default App;

const ProtectedRoute = ({ children }) => {
  const {
    isAuthenticated,
    login,
    isRole,
    isRolesSet,
    initializeAndFetchRoles,
  } = useAuth();
  const { inProgress } = useMsal(); // Ensure no interaction is in progress
  const location = useLocation();
  const { agreementPublicId } = useParams();
  const { setAgreementPublicId } = useSidebar(); // Sidebar state

  console.log("Agreement Public ID: ", agreementPublicId);
  useEffect(() => {
    setAgreementPublicId(agreementPublicId);
  }, [agreementPublicId]);

  useEffect(() => {
    if (!isAuthenticated && inProgress === InteractionStatus.None) {
      console.log("Starting login process...");
      // Check if the user is not authenticated and no interaction is in progress
      sessionStorage.setItem("redirectPath", location.pathname); // Store the current path before redirecting
      login(); // Trigger login if the user is not authenticated
    }
  }, [isAuthenticated, login, inProgress, location]);

  if (inProgress === "startup" || inProgress === "login") {
    return <LoadingPage />;
  }

  if (isAuthenticated && !isRolesSet) {
    initializeAndFetchRoles();
  }

  if (isRolesSet && (isRole("diflexadmin") || isRole("Admin"))) {
    return children;
  } else if (isRolesSet) {
    return <AccessDeniedPage />;
  } else {
    return <LoadingPage />;
  }
};
